import { cn } from "@/lib/utils";

/**
 * Shimmer placeholder for async content. Reach for this whenever a surface
 * is loading — it's the default loading treatment across the app.
 *
 * Usage:
 *   <Skeleton className="h-5 w-24" />
 *   <Skeleton className="h-9 w-full rounded-md" />
 *
 * The subtle pulse comes from Tailwind's `animate-pulse`; color is our
 * card-2 token so skeletons tint to match their surrounding surface in
 * both light and dark themes.
 */
export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-xl bg-surface-elevated", className)}
      aria-hidden="true"
      {...props}
    />
  );
}
